module.exports = __webpack_public_path__ + "img/1594892414.f219caa6.jpg";